class FixedHeaderDirective {
    constructor($window, $document, $timeout, $rootScope) {
        this.restrict = 'A';
        this.$window = $window;
        this.$document = $document;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
    }

    link(scope, element, attrs, controllers) {

        const isMobile = () => {
            return window.innerWidth <= 991;
        }

        const alwaysDisplay = () => {
            if (productMenu.length > 0) {
                return true;
            }
            return !isMobile();
        }

        const body = angular.element(this.$document[0].body);
        const SCROLL_DOWN = 1;
        const SCROLL_UP = -1;
        let isFixed = false;
        let isTransition = false;
        let previousScroll = this.$window.scrollY;
        let previousScrollDirection = null;
        let headerHeight = 0;
        let bottomHeaderVisible = false;
        let directionChangeY = null;
        let directionChangeDelta = 0;

        const disableMobile = false;

        let productMenu = document.querySelectorAll('#product-view-container .product-menu');
        let headerProductMenu = document.querySelectorAll('header .product-menu');
        let headerTop = document.getElementsByClassName('header-top');
        let headerbottom = document.getElementsByClassName('header-bottom');

        if (productMenu.length === 0) {
            productMenu = false;
            headerProductMenu = false;
        }

        const recalculate = () => {
            headerHeight = element[0].offsetHeight;

            let scrollDirection = this.$window.scrollY > previousScroll ? SCROLL_DOWN : SCROLL_UP;

            if (previousScrollDirection && previousScrollDirection !== scrollDirection) {
                directionChangeY = this.$window.scrollY;
            }

            previousScroll = this.$window.scrollY;
            previousScrollDirection = scrollDirection;
            directionChangeDelta = Math.abs(this.$window.scrollY - directionChangeY);

            if (alwaysDisplay()) {
                // Desktop
                if (isTransition) {
                    return;
                }

                // let currentBreakpoints = breakpoints();

                switch (isFixed) {
                    case false:
                        // Is static
                        if ((this.$window.scrollY > headerHeight + 50 && scrollDirection === SCROLL_UP) ||
                            (this.$window.scrollY > headerHeight + 200 && scrollDirection === SCROLL_DOWN)) {
                            toFixed();
                        }
                        break;
                    case true:
                        // Is fixed
                        if ((this.$window.scrollY <= headerHeight + 200 && scrollDirection === SCROLL_DOWN) ||
                            (this.$window.scrollY <= headerHeight + 50 && scrollDirection === SCROLL_UP)) {
                            toStatic();
                        }
                        break;
                }
            } else {
                // Mobile
                if (disableMobile && isFixed) {
                    toStatic();
                    return;
                } else if (disableMobile) {
                    return;
                }

                if (isTransition) {
                    return;
                }

                switch (isFixed) {
                    case false:
                        // Is static
                        if (scrollDirection === SCROLL_UP && directionChangeDelta > 20 && this.$window.scrollY > headerHeight + 100) {
                            toFixed();
                        }
                        break;
                    case true:
                        // Is fixed
                        if (scrollDirection === SCROLL_DOWN && this.$window.scrollY > headerHeight + 100) {
                            toStatic();
                        } else if (scrollDirection === SCROLL_UP && this.$window.scrollY <= headerHeight + 100) {
                            toStatic();
                        }
                        break;
                }
            }

            let bottomHeaderTimeout = null;
            let productMenuTimeout = null;

            if (productMenu && headerProductMenu) {
                if (headerTop.length === 0) {
                    return;
                }
                if (productMenu[0].getBoundingClientRect().bottom - headerTop[0].offsetHeight + 50 < 0 && !bottomHeaderVisible) {
                    clearTimeout(bottomHeaderTimeout);
                    bottomHeaderVisible = true;
                    headerbottom[0].style.display = 'block';
                    productMenuTimeout = setTimeout(() => {
                        headerProductMenu[0].classList.remove('not-visible');
                        headerProductMenu[0].classList.add('visible');
                    }, 100);
                } else if (productMenu[0].getBoundingClientRect().bottom - headerTop[0].offsetHeight + 50 > 0 && bottomHeaderVisible) {
                    clearTimeout(productMenuTimeout);
                    bottomHeaderVisible = false;
                    headerProductMenu[0].classList.remove('visible');
                    headerProductMenu[0].classList.add('not-visible');
                    bottomHeaderTimeout = setTimeout(() => {
                        headerbottom[0].style.display = 'none';
                    }, 400);
                }
            }
        }

        const toFixed = () => {
            this.$rootScope.$broadcast("onHeaderToFixedInit", {headerHeight: element[0].offsetHeight});
            isFixed = true;
            isTransition = true;
            element.css({'margin-top': `-${headerHeight}px`});
            element.addClass('fixed');
            body.css({'padding-top': `${headerHeight}px`});
            this.$timeout(() => {
                isTransition = false;
                element.css({'margin-top': null});
                element.css({'transition': 'margin-top .3s'});
                this.$rootScope.$broadcast("onHeaderToFixedComplete", {headerHeight: element[0].offsetHeight});
            }, 100);
        }

        const toStatic = () => {
            this.$rootScope.$broadcast("onHeaderToStaticInit", {headerHeight: element[0].offsetHeight});
            isFixed = false;
            isTransition = true;
            element.css({'margin-top': `-${headerHeight}px`});
            this.$timeout(() => {
                isTransition = false;
                element.css({'margin-top': null});
                element.css({'transition': null});
                element.removeClass('fixed');
                body.css({'padding-top': '0'});
                this.$rootScope.$broadcast("onHeaderToStaticComplete", {headerHeight: element[0].offsetHeight});
            }, 100);
        }

        this.$timeout(() => {
            recalculate();
        }, 1500);

        angular.element(this.$window).on('resize', recalculate);
        angular.element(this.$window).on('scroll', recalculate);

        scope.$on('$destroy', () => {
            angular.element(this.$window).off('resize', recalculate);
            angular.element(this.$window).off('scroll', recalculate);
        });
    }

    static directiveFactory($window, $document, $timeout, $rootScope) {
        'ngInject';
        return new FixedHeaderDirective($window, $document, $timeout, $rootScope);
    }
}

export default FixedHeaderDirective;
